module.exports = __webpack_public_path__ + "static/media/mouth.c669cbfc.png";